module.exports = __webpack_public_path__ + "img/online-shopping.7730b1ed.svg";